import { Flex } from "@aircall/tractor";
import { styled } from "@xstyled/styled-components";

export const Container = styled.div`
  position: relative;
  transition: all 0.7s;
`;

export const AvatarWrapper = styled(Flex)<{ active: boolean }>`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-100%, -50%);
  align-items: center;
  justify-content: flex-end;
  gap: xxxs;
  padding-right: xxs;
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: all 0.3s;
  cursor: pointer;

  .transcript_item:hover & {
    opacity: 1;
  }
`;
